import * as apiActions from '../../API/api';
import produce from 'immer';
import InitialState from '../../InitialState';
// Action Types
const GRADES_REQUESTED = "gradesRequested";
const GRADES_REQUEST_FAILED = "gradesRequestFailed";

const GRADES_RECEIVED = "gradesReceived";


// Action Creators
export const loadGrades = (courseId) => {
    //log.log('loadGrade Action Creator');
    return apiActions.apiCallBegan({
        url:`/marks/api/studentMarks/${courseId}/?format=json`,
        onStart:GRADES_REQUESTED,
        onSuccess:GRADES_RECEIVED,
        onError:GRADES_REQUEST_FAILED
    });
};
export const gradesReceived = (payload) => ({type:GRADES_RECEIVED,payload});

// Reducer
export function studentGrades(state=InitialState.studentGrades,action){
    switch(action.type){
        case GRADES_REQUESTED:
            return produce(state,draftState => {
                //log.log(state);
                draftState.loading = true;
            });
        case GRADES_REQUEST_FAILED:
            return produce(state,draftState => {
                draftState.loading = false;
            });
        case GRADES_RECEIVED:
            return produce(state,draftState => {
                draftState.tableData = action.payload;
                draftState.loading = false;
            })
        default:
            return state;
    }
}